import { render, staticRenderFns } from "./dialog-create-course.vue?vue&type=template&id=13a56e4c&scoped=true"
import script from "./dialog-create-course.vue?vue&type=script&lang=js"
export * from "./dialog-create-course.vue?vue&type=script&lang=js"
import style0 from "./dialog-create-course.vue?vue&type=style&index=0&id=13a56e4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a56e4c",
  null
  
)

export default component.exports